import axios from 'axios';
import { AppUrls } from './Globals';
import { Config } from './Config';
// import { blobToBase64 } from '../utils'

export const documentsRequests = {};

documentsRequests.DownloadDocument = (data) => {
  return axios
    .post(AppUrls.DownloadDocument, Config.SetParameters(data, '', '', ''), Config.ConfigAuth())
    .then(handleResponse);
};

documentsRequests.DocumentUploadEvidence = (data) => {
  console.log('documentsRequests.DocumentUploadEvidence:----------------------: ', data);
  console.log(
    'documentsRequests.DocumentUploadEvidence:-----------Config-----------: ',
    Config.SetParameters(data, '', '', ''),
  );
  return axios
    .post(
      AppUrls.DocumentUploadEvidence,
      Config.SetParameters(data, '', '', ''),
      Config.ConfigAuth(),
    )
    .then(handleResponse);
};

documentsRequests.CargarSeccion = (data) => {
  return axios
    .post(AppUrls.UploadSectionApi, Config.SetParameters(data, '', '', ''), Config.ConfigAuth())
    .then(handleResponse);
};

documentsRequests.ProcessOZForensics = (data) => {
  return axios
    .post(AppUrls.ProcessOZForensics, Config.SetParameters(data, '', '', ''), Config.ConfigAuth())
    .then(handleResponse);
};

documentsRequests.CargarDocumento = (data) => {
  return axios
    .post(AppUrls.UploadDocuments, Config.SetParameters(data, '', '', ''), Config.ConfigAuth())
    .then(handleResponse);
};

documentsRequests.GetOcrData = (data) => {
  return axios
    .post(AppUrls.GetOcrData, Config.SetParameters(data, '', '', ''), Config.ConfigAuth())
    .then(handleResponse);
};

documentsRequests.RegisterMetadata = (data) => {
  return axios
    .post(AppUrls.RegisterMetadata, Config.SetParameters(data, '', '', ''), Config.ConfigAuth())
    .then(handleResponse);
};

documentsRequests.AutographSignDocument = (data) => {
  return axios
    .post(
      AppUrls.AutographSignDocument,
      Config.SetParameters(data, '', '', ''),
      Config.ConfigAuth(),
    )
    .then(handleResponse);
};

documentsRequests.GetFacialComparison = (data) => {
  return axios
    .post(AppUrls.GetFacialComparison, Config.SetParameters(data, '', '', ''), Config.ConfigAuth())
    .then(handleResponse);
};

documentsRequests.RegisterDataTwo = (data) => {
  return axios
    .post(AppUrls.RegisterDataTwo, Config.SetParameters(data, '', '', ''), Config.ConfigAuth())
    .then(handleResponse);
};

documentsRequests.ValidateIdentityData = (data) => {
  return axios
    .post(AppUrls.ValidateIdentityData, Config.SetParameters(data, '', '', ''), Config.ConfigAuth())
    .then(handleResponse);
};

documentsRequests.GetValidateIdentityData = (data) => {
  return axios
    .post(
      AppUrls.GetValidateIdentityData,
      Config.SetParameters(data, '', '', ''),
      Config.ConfigAuth(),
    )
    .then(handleResponse);
};

documentsRequests.GetDocument = (data) => {
  return axios
    .get(
      AppUrls.GetDocument +
        '?document_Id=' +
        data +
        '&&Authorization=' +
        Config.getTokenCurrentUser(),
      Config.ConfigNoAuthDoc(),
    )
    .then(handleDocument);
};

documentsRequests.UploadMinutiae = (data) => {
  return axios
    .post(AppUrls.UploadMinutiae, Config.SetParameters(data, '', '', ''), Config.ConfigAuth())
    .then(handleResponse);
};

documentsRequests.DigitalSignSATDocument = (data) => {
  return axios
    .post(
      AppUrls.DigitalSignSATDocument,
      Config.SetParameters(data, '', '', ''),
      Config.ConfigAuth(),
    )
    .then(handleResponse);
};

documentsRequests.VerifyStatusCertificate = (data) => {
  return axios
    .post(
      AppUrls.VerifyStatusCertificate,
      Config.SetParameters(data, '', '', ''),
      Config.ConfigAuth(),
    )
    .then(handleResponse);
};

documentsRequests.CargaDocumentoWithSection = (data) => {
  return axios
    .post(
      AppUrls.CargaDocumentoWithSection,
      Config.SetParameters(data, '', '', ''),
      Config.ConfigAuth(),
    )
    .then(handleResponse);
};

documentsRequests.UploadDocumentSectionContent = (data) => {
  console.log('UploadDocumentSectionContent', data);
  // console.log("VIDEOData4", data.B64Data)
  // console.log("documentSectionId", data.documentSectionId)

  let formData = new FormData();
  formData.append('DocumentSection_Id', data.documentSectionId);
  formData.append('FileContent', data.B64Data, data.fileName);
  formData.append('Authorization', Config.getTokenCurrentUser());
  return axios({
    method: 'post',
    // url: AppUrls.UploadDocumentSectionContent + "?Authorization=" + Config.getTokenCurrentUser(),
    url: AppUrls.UploadVideoEvidenceContent + '?Authorization=' + Config.getTokenCurrentUser(),
    data: formData,
    headers: new Headers({
      Authorization: `Basic ${Config.getTokenCurrentUser()}`,
      Accept: 'application/json',
      'Content-Type': 'undefined',
      'Access-Control-Allow-Methods': 'POST',
      'Access-Control-Allow-Headers': 'Content-Type, Authorization',
      'Access-Control-Allow-Credentials': 'true',
    }),
  }).then(handleResponseContent);
};

documentsRequests.UploadVideoEvidenceContentJsonResult = (data) => {
  var formData = new FormData();
  formData.append('DocumentSection_Id', data.DocumentSection_Id);
  formData.append('FileContent', data.B64Data, data.fileName);

  console.log('formData', data, formData);

  return axios({
    method: 'post',
    url:
      AppUrls.UploadVideoEvidenceContentJsonResult +
      '?Authorization=' +
      Config.getTokenCurrentUser(),
    data: formData,
    config: Config.ConfigAuth(),
  }).then(handleResponseContent);
};

documentsRequests.DownloadDocumentAsync = async (data) => {
  const response = await axios.post(
    AppUrls.DownloadDocument,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth(),
  );
  return handleResponse(response);
};

let handleResponseContent = (response) => {
  // console.log('Respuesta --- ', response);
  let respObject = response.data; //BodySecurityResponse(response.data);

  // console.log("response.status --- ",response.status )
  if (response.status != 200) {
    let responseObject = {
      message:
        respObject.Messages +
        ' ' +
        (respObject.TansactionId ? respObject.TansactionId : '') +
        ' ' +
        (respObject.statusText ? respObject.statusText : ''),
    };
    let error = respObject.Body || responseObject;
    return Promise.reject(error);
  }
  return respObject;
};

let handleResponse = (response) => {
  // console.log('Respuesta --- ', response);
  let respObject = response.data; //BodySecurityResponse(response.data);
  if (!respObject.IsOK) {
    let responseObject = {
      message:
        respObject.Messages +
        ' ' +
        (respObject.TansactionId ? respObject.TansactionId : '') +
        ' ' +
        (respObject.statusText ? respObject.statusText : ''),
    };
    let error = respObject.Body || responseObject;
    return Promise.reject(error);
  }
  return respObject;
};

// export const documentRequests = {}
function getType(type) {
  switch (type) {
    case '.pdf':
      return 'application/pdf';
    case '.mp4':
      return 'video/mp4';
    case '.jpg':
      return 'image/jpeg';
    case '.mp3':
      return 'audio/mp3';
    default:
      return '.pdf';
  }
}

let handleDocument = (response) => {
  //Se obtiene el tipo de archivo
  const headerval = response.headers['content-disposition'];
  let extFile = '';
  if (headerval.includes('?utf')) {
    extFile = '.pdf';
  } else {
    extFile = '.' + headerval.split('.')[1].substring(0, 3);
  }
  console.log('response.data-------Document Request --------: ', response.data);
  //Create a Blob from the PDF Stream
  const file = new Blob(
    [response.data],
    //{ type: response.data.type }
    { type: getType(extFile) },
  ); //Build a URL from the file

  // let Base64File = null;
  // blobToBase64(file).then(res => {
  //   console.log("blobToBase64-------- Document Request----------", res)
  //   Base64File = res
  // });

  // console.log("response.data-------Document Request -----file--b64---: ", Base64File)
  // console.log("response.data-------Document Request -----file---: ", file)

  const fileURL = URL.createObjectURL(file); //Open the URL on new Window

  let respObject = {
    data: fileURL,
    dataBlob: file,
    url: response.config.url,
    type: getType(extFile),
    extension: extFile,
  };

  if (response.status != 200 && response.statusText != 'OK') {
    let responseObject = {
      message:
        response.Messages +
        ' ' +
        (response.TansactionId ? response.TansactionId : '') +
        ' ' +
        (response.statusText ? response.statusText : ''),
    };
    const error = respObject.Body || responseObject;
    return Promise.reject(error);
  } else {
    return respObject;
  }
};
